module.exports = __webpack_public_path__ + "img/taili2.3b3c40f3.jpg";